<template>
  <div class="left-sidebar-prompt-contianer">
        <TextArea
            v-model="currentJob.getActiveStageJob().settings.prompt"
            :aiCustom="true"
            :border-class="'br-4'"
            :label="promptPlaceholder"
            :max-characters="4000"
            :rows="'4'"
            :isRowDynamic="isRowDynamic"
            :value="currentJob.getActiveStageJob().settings.prompt"
            class="w-100 styled-text-area"
            name="prompt"
            type="text"
            :disabled="true"
        ></TextArea>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import TextArea from '../../../form/TextArea.vue';
import TextInput from '../../../form/TextInput.vue';
import { translate } from '../../../../../../helper/translate';

export default {
  name: 'Prompt',
  props: {
    isRowDynamic: {
      type: Boolean,
      default: false,
    },
  },
  components: {TextInput, TextArea},
  mixins: [store, currentJob],
  data() {
    return {
      promptPlaceholder: translate('Describe what you want to see'),
      negativePlaceholder: translate('What not to see'),
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.left-sidebar-prompt-contianer {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.styled-text-area {
  padding-bottom: 3px;
  border-radius: 9px;
  background: #fff;
  color: #2e2e2e;
  position: relative;

  textarea {
    font-size: 18px !important;
    margin: 40px 20px 0 20px !important;
    padding: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}

.styled-text-input {
  border-radius: 9px;
  border: 1px solid #595959;
  background: #222;
  color: #e8eaed;
}

.vuetiful-ai-input {
  padding: 30px 0 10px 20px;
  .dark-mode & {
    color:#2e2e2e !important;
  }
}

.text-right {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
